var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopupAddNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "matrix(-1 0 0 1 20.5 0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8333 18L4.66667 18C4.22464 18 3.80072 17.8244 3.48816 17.5118C3.17559 17.1993 3 16.7754 3 16.3333L3 4.66667C3 4.22464 3.1756 3.80072 3.48816 3.48816C3.80072 3.1756 4.22464 3 4.66667 3L16.3333 3C16.7754 3 17.1993 3.1756 17.5118 3.48816C17.8244 3.80072 18 4.22464 18 4.66667L18 13.8333L13.8333 18Z",
    fill: "#FFE5F8",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13 18L13 14.6667C13 14.2246 13.1756 13.8007 13.4882 13.4882C13.8007 13.1756 14.2246 13 14.6667 13L18 13",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5 8L10.5 13M13 10.5L8 10.5",
    stroke: "black",
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupAddNotes);
export default __webpack_public_path__ + "static/media/PopupAddNotes.83946c2cbda9f1ba9769d1ce425956d8.svg";
export { ForwardRef as ReactComponent };